import React from "react"

const LinkedinBlack = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
      >
        <path
          d="M23.68 0H3.2C1.4336 0 0 1.4336 0 3.2V23.68C0 25.4464 1.4336 26.88 3.2 26.88H23.68C25.4464 26.88 26.88 25.4464 26.88 23.68V3.2C26.88 1.4336 25.4464 0 23.68 0ZM8.32 10.24V22.4H4.48V10.24H8.32ZM4.48 6.7008C4.48 5.8048 5.248 5.12 6.4 5.12C7.552 5.12 8.2752 5.8048 8.32 6.7008C8.32 7.5968 7.6032 8.32 6.4 8.32C5.248 8.32 4.48 7.5968 4.48 6.7008ZM22.4 22.4H18.56C18.56 22.4 18.56 16.4736 18.56 16C18.56 14.72 17.92 13.44 16.32 13.4144H16.2688C14.72 13.4144 14.08 14.7328 14.08 16C14.08 16.5824 14.08 22.4 14.08 22.4H10.24V10.24H14.08V11.8784C14.08 11.8784 15.3152 10.24 17.7984 10.24C20.3392 10.24 22.4 11.9872 22.4 15.5264V22.4Z"
          fill="black"
        />
      </svg>
    </>
  )
}

export default LinkedinBlack
